import { useParams } from 'react-router-dom';

import { useProjectById, useProjectsMeta } from '../../shared/contexts/Projects.provider';
import { StatLoading } from '../../widgets/stats';
import { ProjectChart } from './ProjectStatsPage';
import { StandaloneProjectStatsPage } from './StandaloneProjectStatsPage';
import { TrelloBoardStatsPage } from './TrelloBoardStatsPage';

// Dispatches /dashboard/projects/:projectId to the right provider's stats page. Adding a future
// provider: one more case here plus its own lightweight stats page — no routing changes.
export function ProjectDetailPage() {
  const { projectId } = useParams();
  const { isReady } = useProjectsMeta();
  const project = useProjectById(projectId);

  // Avoid a flash of the wrong (default Jira) page while the unified project list is still
  // loading on a fresh deep link.
  if (!isReady) return <StatLoading />;

  switch (project?.provider) {
    case 'trello':
      return <TrelloBoardStatsPage />;
    case 'standalone':
      return <StandaloneProjectStatsPage />;
    case 'jira':
    default:
      return <ProjectChart />;
  }
}
